export const YOUTUBE_LIBRARY_SET_INITIAL_STATE = 'YOUTUBE_LIBRARY_SET_INITIAL_STATE';
export const YOUTUBE_LIBRARY_FIND_ALL = 'YOUTUBE_LIBRARY_FIND_ALL';
export const YOUTUBE_LIBRARY_VIEW = 'YOUTUBE_LIBRARY_VIEW';
